import { render, staticRenderFns } from "./vip_header_dialog.vue?vue&type=template&id=e89512ba&scoped=true"
import script from "./vip_header_dialog.vue?vue&type=script&lang=js"
export * from "./vip_header_dialog.vue?vue&type=script&lang=js"
import style0 from "./vip_header_dialog.vue?vue&type=style&index=0&id=e89512ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89512ba",
  null
  
)

export default component.exports